import React from "react";
import Image from "components/image";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import Link from "components/link";
import clsx from "clsx/lite";

const CollectionList = ({ data }) => {
	const { title, subtitle, discountText, collections, gridLayoutOnMobile } = data;

	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-col items-center gap-3 text-center">
				{title &&
					<h2 className={clsx(data.fontLato && "whitespace-break-spaces font-base font-medium text-3xl lg:text-5xl")}>
						{title}
					</h2>
				}
				{subtitle && <p>{subtitle}</p>}
				{discountText &&
					<p className="text-[#713FFE] bg-[#F1ECFE] px-4 py-1.5 w-fit font-bold mb-5">
						{discountText}
					</p>}
			</div>
			<div className={clsx(gridLayoutOnMobile && "grid grid-cols-2 md:flex", "flex gap-4 overflow-auto no-scrollbar")}>
				{collections.map((collection, index) => (
					<Link key={index} to={`/collections/${collection.handle?.current}`}
						className={clsx("relative group", gridLayoutOnMobile ? "min-w-auto md:min-w-56" : "min-w-56")}>
						<Image image={collection?.image} alt={collection?.title} />
						<div className={
							clsx("absolute flex justify-between items-center gap-3 bottom-0",
								"left-0 w-full px-2 py-3 text-left bg-gradient-to-b from-transparent to-black")}>
							<h4 className={
								clsx("text-white line-clamp-1",
									data.reduceItemTitleFontSize && "text-sm md:text-xl font-base font-semibold line-clamp-none")}>
								{collection?.title}
							</h4>
							<Arrow
								className={clsx("group-hover:fill-beige fill-white group-hover:pl-0.5",
									"transition-all duration-300 w-8 flex")} />
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default CollectionList;